import { App } from "components/App"
import React from "react"
import ReactDOM from "react-dom"

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("main")
)
